import ActiveRecord from '../ActiveRecord.js';
import ActiveRecordSource from '../ActiveRecordSource.js';
import JSONAPI from './JSONAPI.js';
/**
 * @memberof activerecord.sources
 */
class ActiveRecordJSONAPISource extends ActiveRecordSource {
    constructor(url, opts = {}) {
        super(url, opts);
        // If a name was not provided, use a camel case version of the noun in the URL
        if (!opts.responseRecordsPropertyName) {
            const parts = url.split('/');
            const noun = parts[parts.length - 1];
            // Remove hypens; Capitalize first letter of each word
            this.responseRecordsPropertyName = noun.replace(/-./g, (firstLetter) => firstLetter.toUpperCase()[1]);
        }
    }
    /**
     * @param {object} props
     * @return {*}
     */
    transformRequestBody(props) {
        const body = { ...props };
        // We know we can remove $status
        delete body.$status;
        Object.keys(body).forEach((key) => {
            // Convert inner ActiveRecord objects into primary key references
            if (body[key] instanceof ActiveRecord) {
                body[key] = body[key].$primaryKey;
            }
        });
        return JSON.stringify(body);
    }
    /**
     * @param {object} response
     * @return {Promise<object>}
     */
    transformResponse(response) {
        return (response.headers.get('Content-Type') === 'application/json'
            ? response.json().then(JSONAPI.parse)
            : Promise.resolve({}));
    }
    /**
     * @param {object} responseBody
     * @return {object}
     */
    transformResponseMetadata(responseBody) {
        return (this.responseMetadataPropertyName && responseBody
            ? getMeta(responseBody, this.responseMetadataPropertyName)
            : responseBody);
    }
}
function getMeta(responseBody, propertyName) {
    const body = responseBody || {};
    const meta = body[propertyName] || {};
    return meta.pagination || {};
}
ActiveRecordJSONAPISource.defaults = {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
};
export default ActiveRecordJSONAPISource;
